import listComponent from '@/util/proto/listComponent'


export default {
  extends: listComponent,

  data() {
    return {
      columns: [
        {
          title: '序号',
          type: 'index',
          align:'center',
          width: 60,
        },
        
        {
          title: '车辆编号',
          key: 'carNo',
          width: 100,
          // sortable:true,
        },
        {
          title: '车架号',
          key: 'frameNo',
          width: 120,
        },
        {
          title: '车牌号',
          key: 'licenseNo',
          minWidth: 100,
        },
        {
          title: '姓名',
          key: 'courierName',
          minWidth: 100,
        },
        {
          title: '联系电话',
          key: 'courierPhone',
          minWidth: 100,
        },
        {
          title: '设备状态',
          key: 'onlineStatusText',
          minWidth: 100,
        },
        
        {
          title: '最后运动时间',
          key: 'lastLocationDateText',
          minWidth: 120,
        },
      ],
      data: [],
      options:{},
      visible:false,
    }
  },


  methods: {

    init(options) {
      this.options = options
      this.visible = true
      this.search()
    },
    search(){

      let params = { search:this.options.companyId, pageSize: this.page.pageSize, pageNum: this.page.pageNum , orders:this.page.orders }
      this.loading = true

      this.$request.statsCompanyCarWarning(params).then(resp => {
        this.loading = false
        this.data = this.$utils.conv(resp.data.list || [] , {lastLocationDate:'datetime','onlineStatus':'$carOnlineState'})
        this.page.total = resp.data.total
      })
    },
  },

  render(){
    const data = this.data || {}

    const title = '车辆异常信息'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} />
      </sl-side-panel>
    )
  }
}
